import * as React from "react"
const SvgTagTrigger = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M11.15 22q-.375 0-.75-.15t-.675-.45l-7.15-7.15q-.3-.3-.438-.662a2.06 2.06 0 0 1 0-1.488q.138-.375.438-.675l7.8-7.825q.275-.276.65-.437A1.9 1.9 0 0 1 11.8 3h7.175q.825 0 1.412.588.588.587.588 1.412v7.175q0 .294-.081.568a6 6 0 0 0-1.919-.664V5h-7.15L4 12.85 11.15 20l.942-.945a6 6 0 0 0 .775 2.053l-.292.292q-.3.3-.675.45t-.75.15" />
    <path d="M15.475 10q.624 0 1.063-.437a1.45 1.45 0 0 0 .437-1.063q0-.625-.438-1.062A1.45 1.45 0 0 0 15.476 7q-.624 0-1.063.438a1.45 1.45 0 0 0-.437 1.062q0 .624.438 1.063.437.437 1.062.437Zm.475 9h1.55v2.2q0 .2.163.25.162.05.287-.1l2.5-3.575a.46.46 0 0 0 .038-.512.46.46 0 0 0-.438-.263H18.5v-2.2q0-.2-.163-.25-.162-.05-.287.1l-2.5 3.575a.46.46 0 0 0-.038.512.46.46 0 0 0 .438.263" />
  </svg>
)
export default SvgTagTrigger
